import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { ADD_ROW, BUY, BUY_SIDE, confirmationDialog, ConvertDuration, ConvertOrderAndTradeStatus,  
   ConvertOrderType, ConvertSpecialType, DELETE_ROW, DELETE_TABLE, EVENT_TOPIC_FOR_TRANSACTION_SERVER, 
   EVENT_TYPE_CANCEL_ORDER, FormatWithDecimals, Get10Power, JSON_KEY_CANCEL, 
   JSON_KEY_DURATION, JSON_KEY_INSTRUMENT, JSON_KEY_MESSAGE_TYPE, JSON_KEY_MODIFY, 
   JSON_KEY_ORDER_AMEND_NUMBER, JSON_KEY_ORDER_NUMBER, JSON_KEY_ORDER_TYPE, 
   JSON_KEY_ORIGINAL_QTY, JSON_KEY_PAIR_ORDER_NUMBER, JSON_KEY_PRICE, JSON_KEY_PRIORITY, JSON_KEY_REASON, 
   JSON_KEY_SESSION_TYPE, 
   JSON_KEY_SPECIAL_TYPE, JSON_KEY_STATUS, JSON_KEY_SUBMITTER, JSON_KEY_TIME, 
   JSON_KEY_TOTAL_BALANCE, JSON_KEY_TRADING_ACCOUNT, JSON_KEY_TRIGGER_CONDITION, JSON_KEY_TRIGGER_PRICE, JSON_KEY_USER, JSON_KEY_VALUE, 
   JSON_KEY_VERB, JSON_KEY_VISIBLE_BALANCE, JSON_KEY_VISIBLE_QTY, MARKET, OPEN, SELL, 
   TABLE_HEADER_AMEND_NUMBER, TABLE_HEADER_CANCEL, TABLE_HEADER_DURATION, 
   TABLE_HEADER_INSTRUMENT, TABLE_HEADER_MODIFY, TABLE_HEADER_ORDER_NUMBER, 
   TABLE_HEADER_ORDER_TYPE, TABLE_HEADER_ORIGINAL_QTY, TABLE_HEADER_PAIR_ORDER_NUMBER, TABLE_HEADER_PRICE, 
   TABLE_HEADER_PRIORITY, TABLE_HEADER_REASON, TABLE_HEADER_SESSION_TYPE, TABLE_HEADER_SPECIAL_TYPE, 
   TABLE_HEADER_STATUS, TABLE_HEADER_SUBMITTER, TABLE_HEADER_TIME, 
   TABLE_HEADER_TOTAL_BALANCE, TABLE_HEADER_TRADING_ACCOUNT, TABLE_HEADER_TRIGGER_CONDITION, TABLE_HEADER_TRIGGER_PRICE, TABLE_HEADER_USER, 
   TABLE_HEADER_VALUE, TABLE_HEADER_VERB, TABLE_HEADER_VISIBLE_BALANCE, 
   ConvertFromSessionType, SCHEDULE_FLAG, TRIGGER_FLAG,
   TABLE_HEADER_VISIBLE_QTY, UNPLACED, UPDATE_ROW, verbColor,
   ConvertFromTriggerCondition,
   JSON_KEY_CANCEL_ORDER_PAIR,
   YES,
   NO,
   TABLE_HEADER_TRIGGER_DURATION,
   orderRowOpacityForStatus,
   JSON_KEY_TRIGGER_DURATION} 
from '../../common/common';
import { useSelector } from 'react-redux';
import { selectIsMarketController, selectOrderPair, selectOrdersRequest, selectTableData } from '../../redux/globalsSlice';
import { DispatchTransactionEvent } from '../events/events';
import { OrderAmendForm } from '../forms/order_amend_cancel/order_amend_form';
import { Modal } from 'react-bootstrap';
import { MSGTYPE_ORDER_CANCEL } from '../../common/msg_types';
import VirtualizedTablesTemplate from './VirtualizedTablesTemplate';
import OrderRequestForm from '../forms/order_request';
import { selectInstruments, selectTradingUsers } from '../../redux/dropDownSlice';
import { OrderPairAmendForm } from '../forms/order_pair_amend_form/order_pair_amend_form';

function orderStatusColor(rawStatus) {
   const s = String(rawStatus ?? '').trim().toUpperCase();
   switch (s) {
      case 'OPEN':
      case 'UNPLACED':
      case 'MATCHED':
      case 'TRIGGERED':
         return '#4caf50';   // green
      case 'AMENDED':
      case 'CANCELLED':
         return '#5FA8F5';   // blue
      case 'WORKING':
      case 'EXPIRED':
         return '#8F96A0';   // grey
      case 'FAILED':
      case 'REJECTED':
         return '#e74c3c';   // red
      default:
         return '#e8eef7';   // default text
   }
}

function orderNumberColor(rawStatus) {
   const s = String(rawStatus ?? '').trim().toUpperCase();
   switch (s) {
      case 'OPEN':
      case 'UNPLACED':
         return '#5FA8F5';   // blue for live orders
      case 'FAILED':
      case 'REJECTED':
         return '#e74c3c';   // red
      default:
         return '#8F96A0';   // grey for everything else (cancelled, expired, matched, etc.)
   }
}

const UsersOrders2 = () => {
   const instrumentsTableData = useSelector(selectTableData);
   const instrumentsTableDataRef = useRef({});
   const [showAmendForm, setShowAmendForm] = useState(null);
   const [showOrderPairAmendForm, setShowOrderPairAmendForm] = useState(null);
   const [showOrdersRequestForm, setShowOrdersRequestForm] = useState(null);
   const [selectedRow, setSelectedRow] = useState(null);
   const [selectedPairRow, setSelectedPairRow] = useState(null);
   const ordersRequestForm = useSelector(selectOrdersRequest);
   const orderRequestFormRef = useRef(ordersRequestForm);
   const dropDownInstrumentsData = useSelector(selectInstruments);
   const dropDownTradingUsersData = useSelector(selectTradingUsers);
   const orderPair = useSelector(selectOrderPair); 
   const isMarketController = useSelector(selectIsMarketController);
   
   // RAW DATA STORE - Map for O(1) lookups
   const rawDataStore = useRef(new Map());
   
   // CRITICAL FIX: Track which IDs changed in this batch
   const changedIdsRef = useRef(new Set());
   const messageQueueRef = useRef([]);
   const flushTimerRef = useRef(null);
   const isMountedRef = useRef(true);

   const handleCloseAmendForm = () => {
      setShowAmendForm(false);
      setSelectedRow(null);
   };
   
   const handleCloseOrderPairAmendForm = () => {
      setShowOrderPairAmendForm(false);
      setSelectedRow(null);
   };
   
   const columnStyling = useMemo(() => ({
      verb: (rowData) => ({
         color: verbColor(rowData.verb),
      }),
      [JSON_KEY_ORDER_NUMBER]: (rowData) => ({
         paddingLeft: rowData.__isSubRow ? '3rem' : '0.5rem',
         color: orderNumberColor(rowData.status),
      }),
      [JSON_KEY_CANCEL]: () => ({
         justifyContent: 'center',
         display: 'flex',
         alignItems: 'center',
      }),
      [JSON_KEY_MODIFY]: () => ({
         justifyContent: 'center',
         display: 'flex',
         alignItems: 'center',
      }),
      [JSON_KEY_STATUS]: (rowData) => ({
         color: orderStatusColor(rowData.status),
      }),
   }), []);

   useEffect(() => {
      instrumentsTableDataRef.current = instrumentsTableData;
   }, [instrumentsTableData]);

   useEffect(() => {
      isMountedRef.current = true;
      return () => {
         isMountedRef.current = false;
         if (flushTimerRef.current) {
            clearTimeout(flushTimerRef.current);
         }
      };
   }, []);

   useEffect(() => {
      orderRequestFormRef.current = ordersRequestForm;
   }, [ordersRequestForm]);

   const handleSingleClick = useCallback((rowData) => {
      // console.log(`[UsersOrdersTable] Row Clicked:`, rowData);
   }, []);

   const handleDoubleClick = useCallback((rowData) => {
      // console.log(`[UsersOrdersTable] Row Double Clicked:`, rowData);
      if (orderRequestFormRef.current) {
         setSelectedRow(rowData);
         setShowOrdersRequestForm(true);
      }
   }, []);

   const handleEmptyTableClick = useCallback((rowData) => {
      console.log(`[UsersOrdersTable] Empty Row Double Clicked:`, rowData, ', showOrdersRequestForm:', orderRequestFormRef.current);
      if (orderRequestFormRef.current) {
         setSelectedRow(rowData);
         setShowOrdersRequestForm(true);
      }
   }, []);

   const handleCloseOrdersRequestForm = () => {
      setShowOrdersRequestForm(false);
      setSelectedRow(null);
   };

   // Process row with all formatting
   const processRow = useCallback((rawData) => {
      const code = rawData.instr;
      const instrumentRow = instrumentsTableDataRef.current[code];
      const price_dec = instrumentRow?.price_dec ?? 0;
      const qty_dec = instrumentRow?.qty_dec ?? 0;
      
      const hasValidPrice = rawData.price !== undefined && rawData.price !== null && rawData.price !== '';
      const value = hasValidPrice ? rawData.tot_bal * rawData.price : null;

      return {
         ...rawData,
         id: rawData.id,
         dur: ConvertDuration(rawData.dur),
         price: rawData.o_type !== MARKET ? FormatWithDecimals(rawData.price, price_dec) : rawData.price,
         orig_qty: FormatWithDecimals(rawData.orig_qty, qty_dec),
         vis_qty: FormatWithDecimals(rawData.vis_qty, qty_dec),
         tot_bal: FormatWithDecimals(rawData.tot_bal, qty_dec),
         vis_bal: FormatWithDecimals(rawData.vis_bal, qty_dec),
         val: hasValidPrice ? FormatWithDecimals(value / Get10Power(qty_dec), price_dec) : '',
         o_type: ConvertOrderType(rawData.o_type),
         verb: rawData.verb === BUY_SIDE ? BUY : SELL,
         s_type: ConvertSpecialType(rawData.s_type),
         reason: ConvertOrderAndTradeStatus(rawData.reason),
         t_price: (rawData.o_flags & TRIGGER_FLAG) ? FormatWithDecimals(rawData.t_price, price_dec) : null,
         t_con: (rawData.o_flags & TRIGGER_FLAG) ? ConvertFromTriggerCondition(rawData.t_con) : null,
         t_dur: (rawData.o_flags & TRIGGER_FLAG) ? ConvertDuration(rawData.t_dur) : null,
         sess_t: (rawData.o_flags & SCHEDULE_FLAG) ? ConvertFromSessionType(rawData.sess_t) : null,
         status: ConvertOrderAndTradeStatus(rawData.status),
      };
   }, []);

   // ADD THIS: Track every single event that arrives
   const eventLogRef = useRef(new Map()); // Map of order_id -> count
   const totalEventsReceivedRef = useRef(0);
   
   const handleEvents = useCallback((details, setLocalTableData) => {
      const { type, data } = details;
      
      // CRITICAL DEBUG: Log every event that arrives
      const orderId = `${data.o_num}-${data.oa_num}`;
      totalEventsReceivedRef.current++;
      
      // Count how many times we receive events for each order
      const currentCount = eventLogRef.current.get(orderId) || 0;
      eventLogRef.current.set(orderId, currentCount + 1);
      
      // Log if we get duplicate events for the same order
      // if (currentCount > 0) {
      //    console.warn(`[UsersOrdersTable] DUPLICATE EVENT #${currentCount + 1} for order ${orderId}, type: ${type}`);
      // }
      
      // Queue the message
      messageQueueRef.current.push({ type, data });

      if (!flushTimerRef.current && isMountedRef.current) {
         flushTimerRef.current = setTimeout(() => {
            // const startTime = performance.now();
            // const queuedMessages = messageQueueRef.current.length;
            
            // Count unique orders
            const uniqueOrders = new Set();
            messageQueueRef.current.forEach(({ data }) => {
               uniqueOrders.add(`${data.o_num}-${data.oa_num}`);
            });
            
            // console.log(`[UsersOrdersTable] Batch: ${queuedMessages} queued messages, ${uniqueOrders.size} unique orders, TOTAL EVENTS RECEIVED: ${totalEventsReceivedRef.current}`);
            
            // Find duplicates
            const duplicates = [];
            eventLogRef.current.forEach((count, orderId) => {
               if (count > 1) {
                  duplicates.push(`${orderId}: ${count} times`);
               }
            });
            
            // if (duplicates.length > 0) {
            //    console.error(`[UsersOrdersTable] FOUND ${duplicates.length} ORDERS WITH DUPLICATE EVENTS:`, duplicates.slice(0, 10));
            // }

            changedIdsRef.current.clear();
            
            for (const { type, data } of messageQueueRef.current) {
               const id = `${data.o_num}-${data.oa_num}`;

               switch (type) {
                  case ADD_ROW:
                     if (!rawDataStore.current.has(id)) {
                        rawDataStore.current.set(id, { ...data, id });
                        changedIdsRef.current.add(id);
                     } else {
                        console.warn(`[UsersOrdersTable] Skipping duplicate ADD_ROW for ${id}`);
                     }
                     break;

                  case UPDATE_ROW:
                     rawDataStore.current.set(id, { ...data, id });
                     changedIdsRef.current.add(id);
                     break;

                  case DELETE_ROW:
                     // If the message contains a valid oa_num, treat it as a single-row delete.
                     if (data.oa_num !== undefined && data.oa_num !== null && data.oa_num !== '') {
                        // console.log('deteling a row ', data.o_num, ', ', data.oa_num);
                        const id = `${data.o_num}-${data.oa_num}`;
                        if (rawDataStore.current.has(id)) {
                           rawDataStore.current.delete(id);
                           changedIdsRef.current.add(id);
                        }
                     } else {
                        // No oa_num provided → delete ALL rows with this o_num.
                        const oNum = data.o_num;
                        const keysToDelete = [];
                        
                        // console.log('deteling all rows ', data.o_num, ', ', data.oa_num);
                        // Collect all keys whose value has the matching o_num.
                        for (const [key, value] of rawDataStore.current) {
                           if (String(value.o_num) === String(oNum)) {
                              keysToDelete.push(key);
                           }
                        }
                        
                        // Remove all collected keys.
                        keysToDelete.forEach(key => {
                           rawDataStore.current.delete(key);
                           changedIdsRef.current.add(key);
                        });
                     }
                     break;

                  case DELETE_TABLE:
                     console.log('[UsersOrdersTable] DELETE_TABLE event received, clearing all data');
                     rawDataStore.current.clear();
                     setLocalTableData([]);                     
                     break;

                  default:
                     console.warn(`[UsersOrdersTable] Unknown event type: ${type}`);
                  break;
               }
            }

            messageQueueRef.current = [];
            
            // const processingStart = performance.now();
            
            const changedIds = Array.from(changedIdsRef.current);
            const processedChanges = changedIds
               .filter(id => rawDataStore.current.has(id))
               .map(id => processRow(rawDataStore.current.get(id)));
            
            // const processingTime = performance.now() - processingStart;
            
            setLocalTableData(prev => {
               const updated = new Map(prev.map(r => [r.id, r]));
               
               changedIds.forEach(id => {
                  if (!rawDataStore.current.has(id)) {
                     updated.delete(id);
                  }
               });
               
               processedChanges.forEach(row => {
                  updated.set(row.id, row);
               });
               
               return Array.from(updated.values());
            });
            
            // const totalTime = performance.now() - startTime;
            // console.log(`[UsersOrdersTable] Batch complete: ${queuedMessages} messages → ${changedIds.length} changed → ${rawDataStore.current.size} total rows in ${processingTime.toFixed(0)}ms (total: ${totalTime.toFixed(0)}ms)`);
            
            changedIdsRef.current.clear();
            flushTimerRef.current = null;
         }, 500);
      }
   }, [processRow]);

   const SubmitOrderWithdraw = async (o_num, verb, instr, is_pair_order) => {
      const confirmed = await confirmationDialog({ 
         title: 'Cancel Order?', 
         message: `Are you sure you want to cancel order ${o_num}?` 
      });
      if (confirmed) {
         const cancel_order = {
            [JSON_KEY_MESSAGE_TYPE]: MSGTYPE_ORDER_CANCEL,
            [JSON_KEY_ORDER_NUMBER]: o_num,
            [JSON_KEY_CANCEL_ORDER_PAIR]: is_pair_order,
         }
         DispatchTransactionEvent(EVENT_TOPIC_FOR_TRANSACTION_SERVER, EVENT_TYPE_CANCEL_ORDER, cancel_order);
      }
   }

   const columns = useMemo(() => {
      const baseColumns = [
         { 
            Header: TABLE_HEADER_ORDER_NUMBER, 
            accessor: JSON_KEY_ORDER_NUMBER,
            minWidth: 90,
            maxWidth: 130
         },
         { 
            Header: TABLE_HEADER_AMEND_NUMBER, 
            accessor: JSON_KEY_ORDER_AMEND_NUMBER,
            minWidth: 70,
            maxWidth: 100
         },
         { 
            Header: TABLE_HEADER_TIME, 
            accessor: JSON_KEY_TIME,
            minWidth: 200,
            maxWidth: 240
         },
         { 
            Header: TABLE_HEADER_INSTRUMENT, 
            accessor: JSON_KEY_INSTRUMENT,
            minWidth: 120,
            maxWidth: 150
         },
         { 
            Header: TABLE_HEADER_TRADING_ACCOUNT, 
            accessor: JSON_KEY_TRADING_ACCOUNT,
            minWidth: 100,
            maxWidth: 200
         },
         { 
            Header: TABLE_HEADER_VERB, 
            accessor: JSON_KEY_VERB,
            minWidth: 60,
            maxWidth: 80
         },
         { 
            Header: TABLE_HEADER_ORDER_TYPE, 
            accessor: JSON_KEY_ORDER_TYPE,
            minWidth: 40,
            maxWidth: 100
         },
         // PAIR COLUMN WILL BE INSERTED HERE (after ORDER_TYPE)
         { 
            Header: TABLE_HEADER_SPECIAL_TYPE, 
            accessor: JSON_KEY_SPECIAL_TYPE,
            minWidth: 80,
            maxWidth: 130
         },
         { 
            Header: TABLE_HEADER_PRIORITY, 
            accessor: JSON_KEY_PRIORITY,
            minWidth: 70,
            maxWidth: 100
         },
         { 
            Header: TABLE_HEADER_DURATION, 
            accessor: JSON_KEY_DURATION,
            minWidth: 70,
            maxWidth: 120
         },
         { 
            Header: TABLE_HEADER_PRICE, 
            accessor: JSON_KEY_PRICE,
            minWidth: 100,
            maxWidth: 120
         },
         { 
            Header: TABLE_HEADER_ORIGINAL_QTY, 
            accessor: JSON_KEY_ORIGINAL_QTY,
            minWidth: 80,
            maxWidth: 120
         },
         { 
            Header: TABLE_HEADER_TOTAL_BALANCE, 
            accessor: JSON_KEY_TOTAL_BALANCE,
            minWidth: 90,
            maxWidth: 130
         },
         { 
            Header: TABLE_HEADER_VISIBLE_QTY, 
            accessor: JSON_KEY_VISIBLE_QTY,
            minWidth: 80,
            maxWidth: 120
         },
         { 
            Header: TABLE_HEADER_VISIBLE_BALANCE, 
            accessor: JSON_KEY_VISIBLE_BALANCE,
            minWidth: 90,
            maxWidth: 130
         },
         { 
            Header: TABLE_HEADER_TRIGGER_CONDITION, 
            accessor: JSON_KEY_TRIGGER_CONDITION,
            minWidth: 90,
            maxWidth: 130
         },
         { 
            Header: TABLE_HEADER_TRIGGER_DURATION, 
            accessor: JSON_KEY_TRIGGER_DURATION,
            minWidth: 90,
            maxWidth: 130
         },
         { 
            Header: TABLE_HEADER_TRIGGER_PRICE, 
            accessor: JSON_KEY_TRIGGER_PRICE,
            minWidth: 90,
            maxWidth: 130
         },
         { 
            Header: TABLE_HEADER_SESSION_TYPE, 
            accessor: JSON_KEY_SESSION_TYPE,
            minWidth: 90,
            maxWidth: 130
         },
         { 
            Header: TABLE_HEADER_STATUS, 
            accessor: JSON_KEY_STATUS,
            minWidth: 80,
            maxWidth: 120
         },
         { 
            Header: TABLE_HEADER_REASON, 
            accessor: JSON_KEY_REASON,
            minWidth: 100,
            maxWidth: 200
         },
         { 
            Header: TABLE_HEADER_VALUE, 
            accessor: JSON_KEY_VALUE,
            minWidth: 80,
            maxWidth: 200
         },
         { 
            Header: TABLE_HEADER_USER, 
            accessor: JSON_KEY_USER,
            minWidth: 80,
            maxWidth: 150
         },
         { 
            Header: TABLE_HEADER_SUBMITTER, 
            accessor: JSON_KEY_SUBMITTER,
            minWidth: 80,
            maxWidth: 150
         },
         { 
            Header: TABLE_HEADER_CANCEL, 
            accessor: JSON_KEY_CANCEL,
            disableSortBy: true,
            width: 80,
            Cell: ({ row }) => {
               const isSubRow = row.original?.__isSubRow === true;
               if (isSubRow) return null;

               const isOpen = ((row.original.status === OPEN) || (row.original.status === UNPLACED));
               if (!isOpen) return null;

               const is_pair_order = row.original.pair != null && row.original.pair !== '';
               const button_name = is_pair_order ? 'Cancel Pair' : 'Cancel';
               const cancel_pair = is_pair_order ? YES : NO;

               return (
                  <button
                     type="button"
                     className="btn btn-warning btn-sm"
                     style={{ fontSize: '0.60rem', padding: '2px 2px' }}
                     onClick={(e) => {
                        e.stopPropagation();
                        SubmitOrderWithdraw(row.original.o_num, row.original.verb, row.original.instr, cancel_pair);
                     }}
                     disabled={!isOpen}
                     title="Cancel this order"
                  >
                     {button_name}
                  </button>
               );
            },
         },
         { 
            Header: TABLE_HEADER_MODIFY, 
            accessor: JSON_KEY_MODIFY,
            disableSortBy: true,
            width: 80,
            Cell: ({ row }) => {
               const isSubRow = row.original?.__isSubRow === true;
               if (isSubRow) return null;
         
               const isOpen = ((row.original.status === OPEN) || (row.original.status === UNPLACED));
               if (!isOpen) return null;
         
               const is_pair_order = row.original.pair != null && row.original.pair !== '';
               const button_name = is_pair_order ? 'Replace' : 'Modify';

               return (
                  <button
                     type="button"
                     className="btn btn-info btn-sm"
                     style={{ fontSize: '0.60rem', padding: '2px 4px' }}
                     onClick={(e) => {
                        e.stopPropagation();

                        const clickedRow = row.original;

                        setSelectedRow(clickedRow);

                        if (is_pair_order) {

                           // Find all rows matching the pair order number
                           const matchingRows = Array.from(rawDataStore.current.values()).filter(
                              r => String(r.o_num) === String(clickedRow.pair)
                           );

                           // Find row with highest amend number
                           const latestPairRow = matchingRows.reduce((highest, current) => {
                              if (!highest) return current;

                              return Number(current.oa_num) > Number(highest.oa_num)
                                 ? current
                                 : highest;
                           }, null);

                           // Convert RAW row -> formatted row
                           const processedPairRow = latestPairRow
                              ? processRow(latestPairRow)
                              : null;

                           setSelectedPairRow(processedPairRow);

                           setShowOrderPairAmendForm(true);

                        } else {
                           setShowAmendForm(true);
                        }
                     }}
                     title={is_pair_order ? "Replace this order" : "Modify this order"}
                  >
                     {button_name}
                  </button>
               );
            },
         },
      ];
      
      if (orderPair || isMarketController) {
         // Find the index of the ORDER_TYPE column (which is at position 6 based on your array)
         // Or more robustly, find it by accessor
         const orderTypeIndex = baseColumns.findIndex(col => col.accessor === JSON_KEY_ORDER_TYPE);
         
         // Insert the pair column right after ORDER_TYPE
         // The +1 means insert after the found column
         baseColumns.splice(orderTypeIndex + 1, 0, {
            Header: TABLE_HEADER_PAIR_ORDER_NUMBER, 
            accessor: JSON_KEY_PAIR_ORDER_NUMBER, 
            minWidth: 100,
            maxWidth: 150,
         });
      }
      
      return baseColumns;

   }, [orderPair, isMarketController, processRow]);

   return (
      <>
         <div style={{height: '100%', width: '100%', display: 'flex', flexDirection: 'column', overflow: 'hidden'}}>
            <VirtualizedTablesTemplate
               columns={columns}
               eventHandlers={handleEvents}
               tableName="UsersOrdersTable"
               onRowClick={handleSingleClick}
               onRowDoubleClick={handleDoubleClick}
               onEmptyTableClick={handleEmptyTableClick}
               highlightOnClick={true}
               groupBy="o_num"
               subGroupBy="oa_num" 
               enableSearch={true}
               columnStyling={columnStyling}      
               rowStyling={(row) => ({ opacity: orderRowOpacityForStatus(row.status) })}   
               defaultSortBy={[
                  { id: JSON_KEY_ORDER_NUMBER, desc: false },     
               ]}
               enableBatching={false}
            />
            <Modal show={showAmendForm} onHide={handleCloseAmendForm}>
               {showAmendForm && (<OrderAmendForm rowData={selectedRow} onClose={handleCloseAmendForm}/>)}
            </Modal>

            <Modal show={showOrderPairAmendForm} onHide={handleCloseOrderPairAmendForm}>
               {showOrderPairAmendForm && (<OrderPairAmendForm rowData={selectedRow} pairRowData={selectedPairRow} onClose={handleCloseOrderPairAmendForm}/>)}
            </Modal>

            <Modal show={showOrdersRequestForm} onHide={handleCloseOrdersRequestForm}>
               {showOrdersRequestForm && (<OrderRequestForm onClose={handleCloseOrdersRequestForm} usersOptions={dropDownTradingUsersData} instrumentsOptions={dropDownInstrumentsData} />)}
            </Modal>
         </div>
      </>
   );
};

export default UsersOrders2;